import { render, staticRenderFns } from "./APictureSlide.vue?vue&type=template&id=1c482008&scoped=true&"
import script from "./APictureSlide.vue?vue&type=script&lang=js&"
export * from "./APictureSlide.vue?vue&type=script&lang=js&"
import style0 from "./APictureSlide.vue?vue&type=style&index=0&id=1c482008&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c482008",
  null
  
)

export default component.exports